import { render, staticRenderFns } from "./second-level-category-page.vue?vue&type=template&id=fe3357ec"
import script from "./second-level-category-page.vue?vue&type=script&lang=js"
export * from "./second-level-category-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports